import React from "react";
import Button from "@mui/material/Button";
import Spinner from "../../../components/spinner";
import Loader from "../../../components/loader";
import Errors from "../../../pages/errors";
import SwitchToggle from "../../../components/elements/switchtoggle/SwitchToggle";
import usePitchDeckList from "../../../hooks/pitchdeck/usePitchDeckList";

function PitchDeck() {
    const {
        pitchDeckData,
        pitchDeckStatus,
        isToggleLoading,
        handlePitchDeckStatusChange,
        header,
        handleHeaderChange,
        script,
        handleScriptChange,
        handleSaveData,
        isUpdating,
        isDataChanged,
    } = usePitchDeckList();

    return (
        <div className="pitch_deck px-4">
            <div className="blog__head headingBorder__b mb-6">
                <h2 className="titleHeading">Pitch Deck Management</h2>
            </div>

            {pitchDeckData?.isLoading ? (
                <Spinner />
            ) : pitchDeckData?.status === "error" ? (
                <Errors errorObject={pitchDeckData.error} inline />
            ) : (
                <div className="bg-white p-6 rounded-lg shadow space-y-8">
                    {/* Status Toggle Area */}
                    <div className="flex items-center justify-between border-b pb-6">
                        <div>
                            <h3 className="text-lg font-medium text-gray-900">Pitch Deck Visibility</h3>
                            <p className="text-sm text-gray-500 mt-1">Enable or disable the Pitch Deck section on Giant Spell.</p>
                        </div>
                        <div className="flex items-center">
                            <SwitchToggle
                                label={pitchDeckStatus ? "Enabled" : "Disabled"}
                                name="pitchDeckStatus"
                                checkedValue={pitchDeckStatus}
                                onChange={handlePitchDeckStatusChange}
                                className="mr-2"
                            />
                            {isToggleLoading && <Loader className="text-blue-500 h-4 w-4 ml-2" />}
                        </div>
                    </div>

                    {/* Form Area */}
                    <div className="space-y-6">
                        <div>
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Pitch Deck Content</h3>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Header Title
                                    </label>
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                        value={header}
                                        onChange={handleHeaderChange}
                                        placeholder="Enter Pitch Deck Header"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Figma Script Tag
                                    </label>
                                    <textarea
                                        rows={6}
                                        className="w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm font-mono"
                                        value={script}
                                        onChange={handleScriptChange}
                                        placeholder="<iframe style=&quot;border: 1px solid rgba(0, 0, 0, 0.1);&quot; width=&quot;800&quot; height=&quot;450&quot; src=&quot;...&quot; allowfullscreen></iframe>"
                                    />
                                    <p className="mt-2 text-sm text-gray-500">
                                        Paste the embed or script code provided by Figma.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="flex justify-end pt-4 border-t">
                            <Button
                                variant="contained"
                                onClick={handleSaveData}
                                disabled={!isDataChanged || isUpdating}
                                className="primaryBtn-contained bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md shadow-sm"
                            >
                                <div className="flex items-center gap-2">
                                    {isUpdating && <Loader className="h-4 w-4" />}
                                    Save Changes
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PitchDeck;
